module.exports = __webpack_public_path__ + "img/Flag_of_Myanmar.2d222720.svg";